export const UNIT_MEASUREMENT = [
    {key: "Kg", name: "Кг", code: 7},
    {key: "L", name: "Литр", code: 8},
    {key: "BOUQUET", name: "Букет", code: 9},
    {key: "PACK", name: "Пачка", code: 10},
    {key: "PAIR", name: "Жуфт", code: 11},
    {key: "PORTION", name: "Порция", code: 12},
    {key: "METER_SQUARE", name: "м2", code: 13},
    {key: "METER", name: "м", code: 14},
    {key: "HALF_PORTION", name: "0,5 порция", code: 15},
    {key: "ONE_CASSETTE", name: "1 кассета", code: 16},
    {key: "PCS", name: "дона", code: 17},
    {key: "METER_CUBE", name: "м3", code: 21},
    {key: "GRAM", name: "гр", code: 18},
    {key: "KM", name: "км", code: 22},
    {key: "TON", name: "тонна", code: 23},
    {key: "KIT", name: "комплект", code: 24},
    {key: "TYPE", name: "турига", code: 25},
    {key: "BLOK", name: "блок", code: 26}
];

export const MADE_COUNTRY = [
    {key: "CHINA", name: "Китай"},
    {key: "RUSSIA", name: "Россия"},
    {key: "UZBEKISTAN", name: "Узбекистан"},
    {key: "JAPAN", name: "Япония"},
    {key: "UKRAINE", name: "Украина"},
    {key: "TURKEY", name: "Туркия"}
];

export const PROVINCE = [
    {key: "Xorazm", name: "Xorazm viloyati", id: 1},
    {key: "Toshkent", name: "Toshkent shahari", id: 2},
    {key: "Buxoro", name: "Buxoro viloyati", id: 3},
    {key: "Navoiy", name: "Navoiy viloyati", id: 4},
    {key: "Qoraqalpogiston", name: "Qoraqalpog'iston Respublikasi", id: 5},
    {key: "Samarqand", name: "Samarqand viloyati", id: 6},
    {key: "Jizzax", name: "Jizzax viloyati", id: 7},
    {key: "Qashqadaryo", name: "Qashqadaryo viloyati", id: 8},
    {key: "Surxondaryo", name: "Surxondaryo viloyati", id: 9},
    {key: "Sirdaryo", name: "Sirdaryo viloyati", id: 10},
    {key: "Toshkentv", name: "Toshkent viloyati", id: 11},
    {key: "Namangan", name: "Namangan viloyati", id: 12},
    {key: "Fargona", name: "Farg'ona viloyati", id: 13},
    {key: "Andijon", name: "Andijon viloyati", id: 14}
];

export const PART_CONDITION = [
    {key: "GOOD", name: "Яхши", label: "Яхши"},
    {key: "AVERAGE", name: "Уртача", label: "Уртача"},
    {key: "SATISFACTORY", name: "Коникарли", label: "Коникарли"},
    {key: "OLD", name: "Эски", label: "Эски"},
    {key: "UNSATISFACTORY", name: "Коникарсиз", label: "Коникарсиз"}
];

export const FITMENT_TYPE = [
    {key: "JEWELRY", name: "Заргарлик буюмлари"},
    {key: "BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT", name: "Иншоатлар, узатувчи мосламалар, машина ва асбоб-ускуналар"},
    {key: "INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS", name: "Инструментлар, инвентар, ишчи хайвон, куп йиллик усимликлар ва бошка асосий фондлар"},
];

export const TECHNICAL_CONDITION14 = [
    {key: "New", name: "Янги"},
    {key: "VeryGood", name: "Жуда яхши"},
    {key: "Good", name: "Яхши"},
    {key: "Satisfactory", name: "Қониқарли"},
    {key: "Dissatisfied", name: "Қониқарсиз"}
];

export const TECHNICAL_CONDITION15 = [
    {key: "New", name: "Янги"},
    {key: "VeryGood", name: "Жуда яхши"},
    {key: "Good", name: "Яхши"},
    {key: "Satisfactory", name: "Қониқарли"},
    {key: "ConditionallyAvailable", name: "Шартли равишда яроқли"},
    {key: "Dissatisfied", name: "Қониқарсиз"},
    {key: "ToBad", name: "Қўллашга яроқсиз"}
];

export const FITMENT_PROPERTY_TYPES = [
    {key: 'jewelry', name: 'Заргарлик'},
    {key: 'equipment', name: 'Машина-ускуна'},
    {key: 'inventory', name: 'Товар-моддий захиралар'},
    {key: 'inventory_equipment', name: 'Товар-моддий захиралар ва Машина-ускуна'}
];